import DefaultTermsOfService from '../assets/docs/nimi-terms-of-services.pdf'
import DefaultPrivacyPolicy from '../assets/docs/nimi-privacy-policy.pdf'

export const useTermsFormsForAccount = (account) => {
    
    let privacyPolicy;
    let termsOfService;
    const privacy_policy_type = account?.marketPlace?.privacy_policy_type
    const terms_of_service_type = account?.marketPlace?.terms_of_service_type

    if (!privacy_policy_type) {
        privacyPolicy = account?.marketPlace?.linkPrivacy || DefaultPrivacyPolicy
    } else if (privacy_policy_type === 'default') {
        privacyPolicy = DefaultPrivacyPolicy
    } else if (privacy_policy_type === 'hide') {
        privacyPolicy = 'hide'
    } else if (privacy_policy_type === 'link') {
        privacyPolicy = account?.marketPlace?.linkPrivacy
    } else if (privacy_policy_type === 'pdf') {
        privacyPolicy = account?.marketPlace?.linkPrivacy
    }

    if (!terms_of_service_type) {
        termsOfService = account?.marketPlace?.linkTerms || DefaultTermsOfService
    } else if (terms_of_service_type === 'default') {
        termsOfService = DefaultTermsOfService
    } else if (terms_of_service_type === 'hide') {
        termsOfService = 'hide'
    } else if (terms_of_service_type === 'link') {
        termsOfService = account?.marketPlace?.linkTerms
    } else if (terms_of_service_type === 'pdf') {
        termsOfService = account?.marketPlace?.linkTerms
    }

    return {
        privacyPolicy,
        termsOfService
    }
}
